import { render, staticRenderFns } from "./SSMaintainanceView.vue?vue&type=template&id=0c152b06&scoped=true&"
import script from "./SSMaintainanceView.vue?vue&type=script&lang=js&"
export * from "./SSMaintainanceView.vue?vue&type=script&lang=js&"
import style0 from "./SSMaintainanceView.vue?vue&type=style&index=0&id=0c152b06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c152b06",
  null
  
)

export default component.exports